var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLupa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75206 2.92366C11.6902 4.86176 11.6902 8.00403 9.75206 9.94212C7.81397 11.8802 4.6717 11.8802 2.7336 9.94212C0.795506 8.00403 0.795506 4.86176 2.7336 2.92366C4.6717 0.985569 7.81397 0.985569 9.75206 2.92366",
    stroke: "#BBBFC4",
    strokeWidth: 1.18614,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3504 12.5406L9.74878 9.93896",
    stroke: "#BBBFC4",
    strokeWidth: 1.18614,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLupa);
export default __webpack_public_path__ + "static/media/icon_lupa.50a9f1de76fdc3da8a166a101c94f7cb.svg";
export { ForwardRef as ReactComponent };